import '@/app/app.css';
import './catalog-products.css';

import '@/app/app';
import '@/layouts/main/main';

import { ProductBlock } from '@/features/product-block/product-block';
import { SliderProducts } from '@/features/slider-products/slider-products';
import { CatalogSubcategories } from '@/features/catalog/catalog-subcategories/catalog-subcategories';
import { initCatalogProductsTable } from '@/features/catalog/catalog-products-table/catalog-products-table';
import { initCatalogFilter } from '@/features/catalog/catalog-products-filter/catalog-products-filter';
import { CatalogRange } from '@/features/catalog/catalog-range/catalog-range';
import {CatalogCheckboxGroup} from '@/features/catalog/catalog-checkbox-group';

window.app.ProductBlock = ProductBlock;
window.app.SliderProducts = SliderProducts;

window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.product-block').forEach((element) => new ProductBlock(element));
	document.querySelectorAll('.js-slider-products').forEach((slider) => new SliderProducts(slider));
	new CatalogSubcategories(document.querySelector('.js-catalog-subcategories'));

	const $catalog_table = document.querySelectorAll('.js-catalog-products-table');
	Boolean($catalog_table.length) &&
		$catalog_table.forEach((table) => initCatalogProductsTable(table));

	const $catalog_filter = document.querySelector('.js-catalog-filter');
	$catalog_filter && initCatalogFilter($catalog_filter);

	document
		.querySelectorAll('.js-catalog-range')
		.forEach((element) => element && new CatalogRange(element));
	new CatalogCheckboxGroup(document.querySelectorAll('input[type="checkbox"][data-group]'));
});
